import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import loading from "../assets/svg/loading.svg"
export default function Spinner(){
  useUiTranslation();
    return (
        <div className="bg-black bg-opacity-50 flex items-center justify-center fixed start-0 end-0 bottom-0 top-0 z-40 ">
            <div>
            <img src= {loading}   alt={uiI18n.t("ui.loading_220")} className="h-24"/>
            </div>
        </div>
    )
} 